// ink-component
import React from 'react';
import styled, { ThemeProvider, css } from 'styled-components';

import PaginationItem from './PaginationItem/PaginationItem';
import PaginationSpacer from './PaginationSpacer/PaginationSpacer';
import PaginationMiddleItems from './PaginationMiddleItems/PaginationMiddleItems';

import { paginationCore, paginationTrim } from './styles';

import getGlobalProps from '../../helpers/constants/global-props';

const PaginationWrapper = styled.div`
  ${paginationCore}

  ${({ theme }) =>
    theme.trim &&
    css`
      ${paginationTrim}
    `}
`;

export interface PaginationProps {
  /** Current page for external control. */
  currentPage: number;
  /** The total number of pages. */
  totalPages: number;
  /** An onChange callback that's called on the page change. Passes back the page number. */
  onChange: (page: number) => void;
  /** Removes built-in spacing */
  trim?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** Unique name for analytics purposes. By default, components are not tracked, unless this is set */
  'data-track-name'?: string;
  /** Custom payload to be sent to analytics provider */
  'data-track-payload'?: any;
  /** List of tracked events in the analytics integration */
  'data-track-events'?: string[];
}

const PAGE_RANGE = 5;

const globalProps = getGlobalProps({});

/**
 * @purpose Paginates long lists of items
 * @categories table
 */
function Pagination(props: PaginationProps) {
  if (props.totalPages > 1) {
    return (
      <ThemeProvider
        theme={currentTheme => ({
          ...currentTheme,
          trim: props.trim,
        })}
      >
        <PaginationWrapper {...globalProps} data-testid={props['data-testid']}>
          <PaginationItem page={1} {...props} />
          <PaginationSpacer pageRange={PAGE_RANGE} type="left" {...props} />
          <PaginationMiddleItems pageRange={PAGE_RANGE} {...props} />
          <PaginationSpacer pageRange={PAGE_RANGE} type="right" {...props} />
          <PaginationItem page={props.totalPages} {...props} />
        </PaginationWrapper>
      </ThemeProvider>
    );
  }
  return null;
}

Pagination.defaultProps = {
  trim: false,
  'data-track-events': ['click'],
};

Pagination.displayName = 'Pagination';

export default Pagination;
